import EthereumService from '@/services/ethereum'
import { SHA256 } from '@/utils/hash'
import cookie from '@/utils/cookie'
export default class Service extends EthereumService {
  constructor (options) {
    super()
    this.store = options.store
    this.kulapApi = options.kulapApi
  }

  async updateUserData () {
    if (cookie.get('accessToken') && cookie.get('user')) {
      const { data } = await this.kulapApi.getUserProfile()
      this.store.dispatch('setUser', data)
    } else {
      this.store.dispatch('setUser', {})
    }
  }

  async setUserAuthCookies (data, isRememberMe) {
    let expireInHrs = 12 // 12 Hours
    if (isRememberMe) {
      expireInHrs = 2160 // 3 Months
    }
    cookie.setWithExpireTime('accessToken', data.access_token, expireInHrs)
    cookie.setWithExpireTime('user', data.user, expireInHrs)
    await this.updateUserData()
  }

  async loginWithEmailPassword (email, plainTextPassword, isRememberMe, recaptchaToken) {
    const password = SHA256.hex(plainTextPassword)
    let { data } = await this.kulapApi.postLoginWithEmailPassword(email, password, recaptchaToken)
    if (data && data.user && !data.secretKeyForVerify2FA) { // not required 2fa
      await this.setUserAuthCookies(data, isRememberMe)
    }
    return data
  }

  async loginWithFacebook (uid, accessToken, isRememberMe) {
    let data = {uid, accessToken}
    const referralCode = cookie.get('ref')
    if (referralCode) data.referralCode = referralCode
    const { data: result } = await this.kulapApi.postLoginWithFacebook(data)
    if (result && result.user && !result.secretKeyForVerify2FA) { // not required 2fa
      await this.setUserAuthCookies(result, isRememberMe)
    }
    return result
  }

  async loginWithGoogle (googleUser, isRememberMe) {
    const { id_token: googleIdToken } = await googleUser.getAuthResponse()
    let data = { googleIdToken }
    const referralCode = cookie.get('ref')
    if (referralCode) {
      data.referralCode = referralCode
    }
    const { data: result } = await this.kulapApi.postLoginWithGoogle(data)
    if (result && result.user && !result.secretKeyForVerify2FA) { // not required 2fa
      await this.setUserAuthCookies(result, isRememberMe)
    }
    return result
  }

  async verify2FACode (code, secretKeyForVerify2FA, userId) {
    const { data } = await this.kulapApi.getVerify2FA(code, secretKeyForVerify2FA, userId)
    return data
  }

  async updateUserEmail (email, recaptchaToken) {
    const data = { email, recaptchaToken }
    const { data: result } = await this.kulapApi.updateUserEmail(data)
    return result
  }
}



// WEBPACK FOOTER //
// ./src/features/LoginModal/service.js